/* SmartnetDetailsViewComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./SmartnetDetailsViewRenderer");

class SmartnetDetailsViewComponent extends EventEmitter {
    constructor(logger, gameEditor, userSession, MUF, solutionsManager) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = MUF;
        this._userSession = userSession;
        this._solutionDefinition = solutionsManager.getActiveSolution();
        this._solutionName = this._solutionDefinition.name || "";
        this._device = undefined;
        this._deviceCoverage = undefined;
        this._gameEditor.getTabCmpnt().setDirty(false);

        this._renderer = new Renderer(this);
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        this._device.on("PristinePropertiesChanged", (this._onPristinePropertiesChanged = this._onPristinePropertiesChanged.bind(this)));
        if (!_.isUndefined(this._deviceCoverage)) {
            this._deviceCoverage.on("PristinePropertiesChanged", (this._onPristinePropertiesChanged = this._onPristinePropertiesChanged.bind(this)));
        }
    }

    _unregisterListeners() {
        this._device.removeListener("PristinePropertiesChanged", this._onPristinePropertiesChanged);
        if (!_.isUndefined(this._deviceCoverage)) {
            this._deviceCoverage.removeListener("PristinePropertiesChanged", this._onPristinePropertiesChanged);
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._modalUserFeedback = undefined;
                this._userSession = undefined;
                this._solutionDefinition = undefined;
                this._solutionName = undefined;
                this._device = undefined;
                this._deviceCoverage = undefined;
                this._logger = undefined;
                this._gameEditor = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn(err, "SmartnetDetailsViewComponent.shutdown() error.");
            }
        );
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/
    _onPristinePropertiesChanged(pristineProperties, before) {
        this.emit("PristinePropertiesChanged", pristineProperties, before);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }

    get logger() {
        return this._logger;
    }

    whenModelIsReady() {
        return this._gameEditor
            .whenDeviceIsReady()
            .then(() => {
                this._device = this._gameEditor.getDevice();
                return this._device.loadRelatedCoverage({});
            })
            .then((coverageData) => {
                this._deviceCoverage = coverageData;
                this._registerListeners();
                return Promise.resolve();
            })
            .catch((err) => {
                const errorCode = err.errorCode;
                let errorMsg = "This SmartNet cannot be opened.";

                switch (errorCode) {
                    case "NotAuthorized":
                        errorMsg = 'User not authorized for "View Device Vendor Support Data"';
                }
                this._logger.warn(err, "SmartnetDetailsViewComponent.whenModelIsReady() error");
                this._modalUserFeedback.displayError({
                    errorMsg: errorMsg,
                    errorCode: ""
                });
                return Promise.reject(err);
            });
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = SmartnetDetailsViewComponent;

SmartnetDetailsViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.userSession",
    "$teve.ui.userFeedback",
    "$teve.solutionsManager"
];

SmartnetDetailsViewComponent.$displayDetails = {
    type: "View",
    name: "SmartNet Details",
    icon: "devicemanager.cisco_smartnet",
    shown: true,
    title: "SmartNet Details",
    order: 6
};
